export const STORE_KEY = '$_exercise_mobile';

export const GET_CLASSES = 'GET_CLASSES';

export const GET_EXERCISE_FILTER = 'GET_EXERCISE_FILTER';
export const GET_SUBJECTS_CLASSES = 'GET_SUBJECTS_CLASSES';
export const GET_EXERCISE_DETAIL = 'GET_EXERCISE_DETAIL';
export const GET_QUESTION_EXERCISE = 'GET_QUESTION_EXERCISE';
export const GET_QUESTION_EXERCISE_INFO = 'GET_QUESTION_EXERCISE_INFO';

export const TYPE_RADIO = 'radio';
export const TYPE_CHECKBOX = 'checkbox';
export const TYPE_TRUE_FALSE_NO = 'answer_t_f_no';
export const TYPE_MATH_COL = 'math_col';
export const TYPE_FILL_BLANK = 'fill_blank';
export const TYPE_FILL_SENTENCE = 'fill_sentence';
export const TYPE_SELECT = 'select';
export const TYPE_DOWN_ANSWER = 'down_answer';
export const TYPE_CIRCLE_ANSWER = 'circle_answer';
export const TYPE_X_MARK = 'x_mark_answer';
export const TYPE_GROUP = 'group';
export const TYPE_FILL_INPUT_IMG = 'fill_input_img';
// ExerciseDetail

export const LOCAL_SAVE_EXERCISE_DETAIL = 'LOCAL_SAVE_EXERCISE_DETAIL';
export const OPEN_MATH_FORM = "EMIT_OPEN_MATH_FORM";
export const SEND_MATH_VAL = "EMIT_SEND_MATH_VAL";
export const VALIDATE_QUESTION = "VALIDATE_QUESTION";
export const SET_QUESTION_ACTIVITY = "SET_QUESTION_ACTIVITY";
export const CHECK_CORRECT_QUESTION = "CHECK_CORRECT_QUESTION";
export const SET_QUESTION_VALID_DATA = "SET_QUESTION_VALID_DATA";
export const GET_ALL_CLASSES = 'GET_ALL_CLASSES';
export const GET_EXERCISE_DETAIL_NUMBER = 'GET_EXERCISE_DETAIL_NUMBER';
export const LOCAL_SAVE_SUBJECT_NAME = 'sbnex';
export const LOCAL_SAVE_ID = 'LOCAL_SAVE_ID';
export const GET_PRACTICE_TYPE = 'GET_PRACTICE_TYPE';
export const GET_LIST_PRACTICE_TYPE_BOOK = 'GET_LIST_PRACTICE_TYPE_BOOK';
export const LOCAL_SAVE_QUESTIONS_WORKED = 'quesWorked';
export const LOCAL_SAVE_EXERCISE_DETAIL_ROUTE = 'LOCAL_SAVE_EXERCISE_DETAIL_ROUTE';
export const SET_ACTIVE = 'SET_ACTIVE';
export const LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE1 = 'LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE1';
export const LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE = 'LOCAL_SAVE_EXERCISE_DETAIL_ACTIVE';
export const LOCAL_SAVE_CAT = 'catex';
export const LOCAL_SAVE_BOOK_ACTIVE = 'exbookcurr';
export const LOCAL_SAVE_PRACTICE_LIST = 'pralist';
export const LOCAL_SAVE_BREADCRUMB_CAT = 'brcat';
export const SET_PACTICE_ACTIVE = 'SET_PACTICE_ACTIVE';
export const SET_PACTICE_TYPES_DATA = 'SET_PACTICE_TYPES_DATA';
export const SET_EXERCISE_CLASS_CURR = 'SET_EXERCISE_CLASS_CURR';
export const LOCAL_SAVE_EXERCISE_CLASS = 'lcexerclass';
export const LOCAL_QUESTIONS_DATA = 'lcqdt';
export const SET_QUESTIONS_DATA = 'SET_QUESTIONS_DATA';
export const SET_BOOKINDEX_OF_BOOK = 'SET_BOOKINDEX_OF_BOOK';
export const SET_PARAM_FILTER_EXAM = 'SET_PARAM_FILTER_EXAM';
export const SET_PARAM_FILTER_EX_OTHER_THEMATIC = 'SET_PARAM_FILTER_EX_OTHER_THEMATIC';

export const TYPE_EXERCISE_OTHER = 1;
export const TYPE_EXERCISE_THEMATIC = 2;
export const TYPE_EXERCISE_EXAM = 3;

export const GET_EBOOKS_DETAIL = 'GET_EBOOKS_DETAIL';

export const LOCAL_SAVE_PAGE_OPEN = "page_open";
export const SET_PARAM_SEARCH_RELATE_MEDIA = "SET_PARAM_SEARCH_RELATE_MEDIA";
export const SET_QUESTION_PREVIEW_INFO = "SET_QUESTION_PREVIEW_INFO";
export const EXAM_WORKED_DONE = 1;
export const EXAM_WORKING = 2;
export const EXAM_DONT_WORK = 3;
export const ID_MODAL_PREVIEW_EXERCISE = 'modal_exercise_preview';
export const SER_CATS_FLAT_EXERCISE = 'SER_CATS_FLAT_EXERCISE';
